export { I18NParagraph } from "./I18NParagraph";
export type { I18NParagraphProps } from "./I18NParagraph.interface";